import ReactDOM from 'react-dom/client'
import * as Sentry from "@sentry/react";

import './index.css'
import App from './App.tsx'

Sentry.init({
  dsn: "https://71c63df3564e6a2dd9931bdc738d296d@o4508263033929728.ingest.de.sentry.io/4509134928347216"
});

ReactDOM.createRoot(document.getElementById('root')!).render(

  <App />
  ,
)
